import SupportersBox from './SupportersBox';
import SupportersContainer from './Supporters.container';

export default SupportersContainer(SupportersBox);
